import CircularProgress from '@mui/material/CircularProgress';
import { alpha } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { Box } from 'src/components';
import Backdrop from 'src/components/Backdrop';
import { isVisible } from 'src/utils/formAuthHelper';
import { KeyboardEvent } from "react"
import ModulEnum from "src/enums/ModulEnum";
interface IBaseComponentProps {
  authCode?: string;
  children: React.ReactNode;
  modul?: ModulEnum;
  loading?: boolean;
  onAcceptHandler?: (e?: any) => void;
  onAddHandler?: (e?: any) => void;
  onSaveHandler?: (e?: any) => void;
  onCancelHandler?: (e?: any) => void;
  onBackHandler?: (e?: any) => void;
  onFindHandler?: (e?: any) => void;
}
const BaseComponent = (props: IBaseComponentProps): JSX.Element => {

  const keyFunction = useCallback((e: KeyboardEvent<Body>) => {
    if (props.onAcceptHandler && (e.code === "Enter" || e.code === "NumpadEnter"))
      props.onAcceptHandler(e);
    if (props.onAddHandler && e.code === "F2")
      props.onAddHandler(e);
    if (props.onSaveHandler && e.code === "F4")
      props.onSaveHandler(e);
    if (props.onCancelHandler && e.code === "Escape")
      props.onCancelHandler(e);
    if (props.onBackHandler && e.code === "Backspace")
      props.onBackHandler(e);
    if (props.onFindHandler && e.code === "F8")
      props.onFindHandler(e);
  }, [props]);

  useEffect(() => {
    if (props.onAcceptHandler || props.onAcceptHandler || props.onAddHandler || props.onSaveHandler || props.onCancelHandler || props.onBackHandler || props.onFindHandler) {
      document.addEventListener('keyup', keyFunction as any);
    }
    return () => {
      document.removeEventListener('keyup', keyFunction as any);
    };
  }, [keyFunction, props]);

  return (
    <Box
      sx={{
        // p: 1,
        //bgcolor: 'background.default',
        //display: 'flex',
        //position: 'relative',
        // overflowY: "auto",
        // // height: "calc(100vh - 4.5rem)",
        // paddingBottom: "5px"
        width: '100%'
      }}
    >
      <Backdrop
        open={props.loading ? props.loading : false}
        /*
          Alttaki hata için open'a ? props.loading : false ekleyip düzelttim.
          Failed prop type: The prop `open` is marked as required in `ForwardRef(Backdrop)`, but its value is `undefined`.
        */
        sx={{
          color: (theme) =>
            theme.palette.mode == 'dark'
              ? theme.palette.primary.light
              : theme.palette.primary.dark,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          position: 'absolute',
          borderRadius: (theme) => theme.shape.borderRadius + 'px',
          backgroundColor: (theme) =>
            alpha('rgb(0,0,0)', theme.palette.mode == 'dark' ? 0.5 : 0.2)
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {isVisible(props.authCode, props.modul) && props.children}
    </Box>
  );
};

export default BaseComponent;
